import {
  SortOrder,
  WeeklyWorkListFilterByPlanStatus,
  WeeklyWorkListSearchBy,
  WeeklyWorkListSortByTerm,
} from '@bechtel/types';
import { msg } from '@lingui/macro';
import { PlanStatusType, WorkListDrawerValueProps } from '../worklist/types';

export const initialDrawerValues: WorkListDrawerValueProps = {
  searchBy: WeeklyWorkListSearchBy.TAG_ID,
  filterByCommodity: [],
  filterByMilestoneTypes: [],
  filterByPlanStatusTypes: [],
  sortBy: WeeklyWorkListSortByTerm.TAG,
  sortDir: SortOrder.DESC,
};

export const sortByList = [
  { id: 1, value: WeeklyWorkListSortByTerm.WP_NUMBER, label: msg`Work Package` },
  { id: 2, value: WeeklyWorkListSortByTerm.MILESTONE_TYPE, label: msg`Milestone Sequence` },
  { id: 3, value: WeeklyWorkListSortByTerm.TAG, label: msg`Tag Id` },
];

export const searchByList = [
  {
    id: 1,
    searchByTerm: { type: WeeklyWorkListSearchBy.TAG_ID },
    label: msg`Tag Id or Cost Code`,
  },
  {
    id: 2,
    searchByTerm: { type: WeeklyWorkListSearchBy.USER_ID },
    label: msg`User Name`,
  },
  {
    id: 3,
    searchByTerm: { type: WeeklyWorkListSearchBy.WORKPACKAGE },
    label: msg`Work Package`,
  },
];

export const planStatusList: PlanStatusType[] = [
  { id: 1, value: WeeklyWorkListFilterByPlanStatus.IN_PLAN, label: msg`In Plan` },
  { id: 2, value: WeeklyWorkListFilterByPlanStatus.OUT_OF_PLAN, label: msg`Out of Plan` },
];
